import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#171738' },
    secondary: { main: '#2E1760' },
    tertiary: { main: '#3423A6' },
    placeholder: { main: '#7180B9' },
    black: { main: '#000000' },
    white: { main: '#FFFFFF' },
    clear: { main: '#DFF3E4' },
  },
  typography: {
    heading1: {
      fontFamily: 'Montserrat',
      fontSize: '8rem',
      fontWeight: 700,
      textTransform: 'none',
      color: '#FFFFFF',
      padding: 0,
      margin: 0,
    },
    heading2: {
      fontFamily: 'Montserrat',
      fontSize: '6rem',
      fontWeight: 700,
      color: '#FFFFFF',
    },
    heading3: {
      fontFamily: 'Montserrat',
      fontSize: '4rem',
      fontWeight: 700,
      color: '#FFFFFF',
    },
    heading4: {
      fontFamily: 'Montserrat',
      fontSize: '2.4rem',
      fontWeight: 700,
      color: '#FFFFFF',
    },
    large: {
      fontFamily: 'Montserrat',
      fontSize: '2rem',
      fontWeight: 600,
      color: '#FFFFFF',
    },
    medium: {
      fontFamily: 'Montserrat',
      fontSize: '1.8rem',
      fontWeight: 500,
      color: '#FFFFFF',
    },
    normal: {
      fontFamily: 'Montserrat',
      fontSize: '1.6rem',
      fontWeight: 400,
      color: '#FFFFFF',
    },
    small: {
      fontFamily: 'Montserrat',
      fontSize: '1.4rem',
      fontWeight: 400,
      color: '#FFFFFF',
    },
    menuItems: {
      fontFamily: 'Montserrat',
      fontSize: '1.6rem',
      fontWeight: 400,
      textTransform: 'none',
      textDecoration: 'none',
      color: '#FFFFFF',
    },
    button: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '1.6rem',
      textTransform: 'none',
      textDecoration: 'none',
      color: '#FFFFFF',
    },
  },
  globals: {
    container: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      backgroundColor: '#000000',
      padding: '20px 90px',
    },
    screenContainer: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      backgroundColor: '#000000',
      padding: '20px 90px',
    },
    containerColumnCenterCenterFullscreen: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '20px 90px',
    },
    containerYCenterFullscreen: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      width: '100vw',
      height: '100vh',
    },
    containerYFlexstartFullscreen: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      boxSizing: 'border-box',
      padding: '20px 90px',
    },
    containerYFlexstartLeftFullscreen: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      boxSizing: 'border-box',
      padding: '20px 90px',
    },
    containerYSpacebetweenFullscreen: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '20px 90px',
    },
    containerXSpacebetweenFullscreen: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '20px 90px',
    },
    containerColumnTopLeft: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      boxSizing: 'border-box',
    },
    containerColumnCenterLeft: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      boxSizing: 'border-box',
    },
    containerColumnCenterRight: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-end',
      boxSizing: 'border-box',
    },
    containerRowCenterLeft: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerColumnTopCenter: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerYCenter: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerYCenterRight: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      boxSizing: 'border-box',
    },
    containerYFlexstart: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerYSpacebetween: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerYFlexstartLeft: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      boxSizing: 'border-box',
    },
    containerYFlexendRight: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'end',
      boxSizing: 'border-box',
    },
    containerXCenter: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerXFlexend: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerXSpacebetween: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    containerXFlexstart: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    inputContainer: {
      width: '100vw',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      backgroundColor: '#000000',
      padding: '20px 50px',
    },
    leftAlign: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '100px',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
